<template>
  <div>
    <audioPlayer :src="audio_src"></audioPlayer>
  </div>
</template>

<script>
import audioPlayer from "./../AudioPlayer";
import { mapGetters, mapState } from "vuex";
export default {
  name: "audioPopup",
  props: ["item"],
  components: {
    audioPlayer
  },
  computed: {
    ...mapState([
      "current_section",
      "current_sub_section",
      "current_secondary_section",
      "current_secondary_sub_section",
      "sections_content"
    ]),
    ...mapGetters(["eventTag"]),
    audio_src() {
      return (
        "static/content/" +
        this.selected_section +
        "/" +
        this.selected_sub_section +
        "/pdf/" +
        this.item.filename +
        ""
      );
    },
    selected_section() {
      if (this.current_secondary_section != "") {
        return this.current_secondary_section;
      }
      return this.current_section;
    },
    selected_sub_section() {
      if (this.current_secondary_sub_section != "") {
        return this.current_secondary_sub_section;
      }
      return this.current_sub_section;
    }
  },
  mounted() {
    this.$store.dispatch("set_simple_val", {
      name: "ambience_previous_vol",
      val: this.$store.state.ambience_current_vol
    });
    this.$bus.$emit("on-video-created");
    this.$bus.$emit("on-request-ambience-fade", 0);
  },
  beforeDestroy() {
    if (
      this.$store.state.ambience_previous_vol >= 0 &&
      this.$store.state.ambience_previous_vol !=
        this.$store.state.ambience_current_vol
    ) {
      this.$bus.$emit(
        "on-request-ambience-fade",
        this.$store.state.ambience_max_volume
      );
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/subpopups/audioPopup.vue